import type { SimpleChanges } from '@angular/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  output,
  inject,
  input,
} from '@angular/core';

import type { User } from '@core/account-types';
import { AssignedLocationsInfoContainerComponent } from '@core/locations-smart-ui';
import { OfferSimpleListItem } from '@core/offers-types';
import { OfferStatusIndicatorComponent } from '@core/offers-ui';
import {
  DividerComponent,
  IconButtonComponent,
  HeadingComponent,
  GroupComponent,
} from '@core/user-interface-legacy';
@Component({
  selector: 'rt-offers-simple-list',
  templateUrl: 'offers-simple-list.component.html',
  styleUrls: ['./offers-simple-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-short]': 'isShort()',
  },
  imports: [
    GroupComponent,
    OfferStatusIndicatorComponent,
    HeadingComponent,
    IconButtonComponent,
    DividerComponent,
    AssignedLocationsInfoContainerComponent,
  ],
})
export class OffersSimpleListComponent {
  protected readonly cdRef = inject(ChangeDetectorRef);

  public readonly offers = input<OfferSimpleListItem[]>([]);
  public readonly isShort = input<boolean>(false);
  public readonly markOffersWithoutAccess = input<boolean>(false);
  public readonly editable = input<boolean>(true);
  public readonly admin = input<User | null>(null);

  public removeOffer = output<OfferSimpleListItem>();
  public goToOffer = output<OfferSimpleListItem>();

  public offersWithAccess: { [key: number]: boolean } = {};

  public ngOnChanges(changes: SimpleChanges): void {
    const { admin, offers } = changes;

    const offersValue = this.offers();
    const adminValue = this.admin();
    if (
      ((admin && admin.currentValue) || (offers && offers.currentValue)) &&
      offersValue &&
      adminValue
    ) {
      this.offersWithAccess = this.getOffersWithAccess(offersValue, adminValue);
    }
  }

  public trackByOffer<T extends { id: number }>(index: number, offer: T): number {
    return offer.id;
  }

  private getOffersWithAccess(
    offers: OfferSimpleListItem[],
    admin: User,
  ): { [key: number]: boolean } {
    return offers.reduce(
      (acc, offer) => ({ ...acc, [offer.id]: this.hasAccess(offer.id, admin) }),
      {},
    );
  }

  private hasAccess(offerId: number, admin: User): boolean {
    return admin.viewAllJobs || !!admin.offerIds?.includes(offerId);
  }
}
